import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import Swal from "sweetalert2";

import { CustomBreadCrumb } from "../../../components";
import { PeerGroupForm } from "../../../form";
import { PeerGroupApi } from "../../../api";
import { useAppNavigate, useAppParams } from "../../../Router/hook";
import { Loading } from "../../../components";
import { useAppSelector } from "../../../redux-config/hooks";
import { selectUser } from "../../../redux-config/entities/user";
import { DataPostType } from "../../../DTO";

export const PeerGroupPostEdit: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [post, setPost] = useState<DataPostType>();
    const navigate = useAppNavigate();

    const user = useAppSelector(selectUser);

    const { id, postId } = useAppParams();

    const handlePostEdit = (
        title: string,
        context: string,
        imageId: number[],
    ) => {
        setLoading(true);
        PeerGroupApi.PostApi.EditPost(
            user,
            Number(postId),
            title,
            context,
            imageId,
        )
            .then((data) => {
                navigate(`/peer-group/info/${id}`);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    text: err,
                });
            });
    };

    useEffect(() => {
        fetchSinglePeerGroupPost();
    }, [postId, id]);

    const fetchSinglePeerGroupPost = () => {
        setLoading(true);

        PeerGroupApi.PostApi.ShowPost(user, Number(postId))
            .then((data) => {
                setPost(data.post);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    text: err,
                });
            });
    };

    const crumbs = [
        { name: "", href: "" },
        { name: "Dashboard", href: "/" },
        { name: "Peer Group list", href: "/peer-group/list" },
        { name: "Edit" + postId, href: "#" },
    ];

    return (
        <>
            <Helmet>
                <title>D2Type | Post Edit</title>
                <meta name="description" content="Basic example" />
            </Helmet>
            {loading && <Loading />}
            <div className="d-flex flex-column">
                <CustomBreadCrumb breadCrumbList={crumbs} />
                <div className="d-flex flex-column bg-custom-white rounded p-3">
                    {post && (
                        <Formik<PeerGroupForm.PostForm.FormValues>
                            validationSchema={
                                PeerGroupForm.PostForm.ValidationSchema
                            }
                            initialValues={{
                                title: post.title,
                                content: post.attachments
                                    ? post.attachments
                                    : [],
                                context: post.context,
                            }}
                            onSubmit={(event) => {
                                const imagesId: number[] = event.content.map(
                                    (element) => Number(element.id),
                                );
                                handlePostEdit(
                                    event.title,
                                    event.context,
                                    imagesId,
                                );
                            }}
                            component={(props: any) => (
                                <PeerGroupForm.PostForm.PostCreate
                                    submitTxt={"Submit"}
                                    {...props}
                                />
                            )}
                        />
                    )}
                </div>
            </div>
        </>
    );
};
